var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"transition":"scale-transition","type":"table-tbody"}},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card-title',[_vm._v("Chronic Conditions")]),_c('v-card-text',[_c('pie-chart',{attrs:{"data":_vm.chartDataConditions,"options":_vm.options,"styles":_vm.chartStyles,"chart":'chronic'}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }